import React, { useState } from 'react';
import { useCoffee } from '../context/CoffeeContext';
import { FlavorProfile } from './FlavorProfile';
export const CoffeeForm: React.FC<{
  setActiveTab?: (tab: string) => void;
}> = ({
  setActiveTab
}) => {
  const {
    addCoffeeEntry,
    coffeeBags,
    addCoffeeBag
  } = useCoffee();
  const [showNewBagForm, setShowNewBagForm] = useState(false);
  const [flavorProfile, setFlavorProfile] = useState({
    acidity: 5,
    sweetness: 5,
    bitterness: 5,
    body: 5,
    complexity: 5
  });
  const [formData, setFormData] = useState({
    bagId: '',
    brewMethod: 'Pour Over',
    coffeeWeight: 15,
    waterWeight: 250,
    grindSize: 'Medium',
    waterTemperature: 93,
    totalBrewTime: 180,
    totalBrewTimeDisplay: '03:00',
    pourDetails: '',
    tds: 1.35,
    additionalNotes: ''
  });
  const [newBag, setNewBag] = useState({
    name: '',
    roaster: '',
    origin: '',
    process: '',
    brand: '',
    roastLevel: 'Medium',
    roastDate: '',
    purchaseDate: '',
    notes: ''
  });
  const secondsToTimeDisplay = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };
  const timeDisplayToSeconds = (timeDisplay: string): number => {
    const [minutesPart, secondsPart] = timeDisplay.split(':');
    const minutes = parseInt(minutesPart || '0', 10);
    const seconds = parseInt(secondsPart || '0', 10);
    return minutes * 60 + seconds;
  };
  const calculateExtractionYield = (tds: number, coffeeWeight: number, waterWeight: number) => {
    return tds * waterWeight / coffeeWeight;
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    if (name === 'totalBrewTimeDisplay') {
      const timePattern = /^([0-9]{0,2}):?([0-9]{0,2})$/;
      if (timePattern.test(value)) {
        const formattedValue = value.includes(':') ? value : value.replace(/^(\d{1,2})(\d{0,2})$/, '$1:$2');
        const seconds = timeDisplayToSeconds(formattedValue);
        setFormData({
          ...formData,
          totalBrewTimeDisplay: formattedValue,
          totalBrewTime: seconds
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: name === 'coffeeWeight' || name === 'waterWeight' || name === 'waterTemperature' || name === 'tds' ? parseFloat(value) : value
      });
    }
  };
  const handleNewBagChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setNewBag({
      ...newBag,
      [name]: value
    });
  };
  const handleSubmitNewBag = (e: React.FormEvent) => {
    e.preventDefault();
    const bagId = Date.now().toString();
    addCoffeeBag({
      ...newBag,
      id: bagId
    });
    setFormData({
      ...formData,
      bagId
    });
    setShowNewBagForm(false);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const extractionYield = calculateExtractionYield(formData.tds, formData.coffeeWeight, formData.waterWeight);
    addCoffeeEntry({
      ...formData,
      id: Date.now().toString(),
      date: new Date().toISOString(),
      extractionYield,
      flavorNotes: flavorProfile
    });
    setFormData({
      ...formData,
      pourDetails: '',
      additionalNotes: ''
    });
    setFlavorProfile({
      acidity: 5,
      sweetness: 5,
      bitterness: 5,
      body: 5,
      complexity: 5
    });
    alert('¡Preparación registrada con éxito!');
    // Cambiar a la tab de historial después de guardar
    if (setActiveTab) {
      setActiveTab('list');
    }
  };
  return <div className="max-w-md mx-auto" data-id="element-187">
      <h2 className="text-xl font-bold mb-4 text-amber-900" data-id="element-188">
        Nueva Preparación
      </h2>
      {showNewBagForm ? <div className="bg-white p-4 rounded-lg shadow mb-4" data-id="element-189">
          <h3 className="text-lg font-semibold mb-2 text-amber-800" data-id="element-190">
            Nuevo Café
          </h3>
          <form onSubmit={handleSubmitNewBag} data-id="element-191">
            <div className="mb-3" data-id="element-192">
              <label className="block text-sm font-medium text-amber-700" data-id="element-193">
                Nombre
              </label>
              <input type="text" name="name" value={newBag.name} onChange={handleNewBagChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" required data-id="element-194" />
            </div>
            <div className="mb-3" data-id="element-195">
              <label className="block text-sm font-medium text-amber-700" data-id="element-196">
                Tostador
              </label>
              <input type="text" name="roaster" value={newBag.roaster} onChange={handleNewBagChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" data-id="element-197" />
            </div>
            <div className="mb-3" data-id="element-198">
              <label className="block text-sm font-medium text-amber-700" data-id="element-199">
                Marca/Tienda
              </label>
              <input type="text" name="brand" value={newBag.brand} onChange={handleNewBagChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" placeholder="Tienda donde lo compraste" data-id="element-200" />
            </div>
            <div className="mb-3" data-id="element-201">
              <label className="block text-sm font-medium text-amber-700" data-id="element-202">
                Origen
              </label>
              <input type="text" name="origin" value={newBag.origin} onChange={handleNewBagChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" data-id="element-203" />
            </div>
            <div className="mb-3" data-id="element-204">
              <label className="block text-sm font-medium text-amber-700" data-id="element-205">
                Proceso
              </label>
              <select name="process" value={newBag.process} onChange={handleNewBagChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" data-id="element-206">
                <option value="" data-id="element-207">Seleccionar proceso</option>
                <option value="Lavado" data-id="element-208">Lavado</option>
                <option value="Natural" data-id="element-209">Natural</option>
                <option value="Honey" data-id="element-210">Honey</option>
                <option value="Anaeróbico" data-id="element-211">Anaeróbico</option>
                <option value="Fermentado" data-id="element-212">Fermentado</option>
                <option value="Otro" data-id="element-213">Otro</option>
              </select>
            </div>
            <div className="mb-3" data-id="element-214">
              <label className="block text-sm font-medium text-amber-700" data-id="element-215">
                Nivel de Tueste
              </label>
              <select name="roastLevel" value={newBag.roastLevel} onChange={handleNewBagChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" data-id="element-216">
                <option value="Light" data-id="element-217">Ligero</option>
                <option value="Medium-Light" data-id="element-218">Medio-Ligero</option>
                <option value="Medium" data-id="element-219">Medio</option>
                <option value="Medium-Dark" data-id="element-220">Medio-Oscuro</option>
                <option value="Dark" data-id="element-221">Oscuro</option>
              </select>
            </div>
            <div className="mb-3" data-id="element-222">
              <label className="block text-sm font-medium text-amber-700" data-id="element-223">
                Fecha de Tueste
              </label>
              <input type="date" name="roastDate" value={newBag.roastDate} onChange={handleNewBagChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" data-id="element-224" />
            </div>
            <div className="mb-3" data-id="element-225">
              <label className="block text-sm font-medium text-amber-700" data-id="element-226">
                Fecha de Compra
              </label>
              <input type="date" name="purchaseDate" value={newBag.purchaseDate} onChange={handleNewBagChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" data-id="element-227" />
            </div>
            <div className="mb-3" data-id="element-228">
              <label className="block text-sm font-medium text-amber-700" data-id="element-229">
                Notas
              </label>
              <textarea name="notes" value={newBag.notes} onChange={handleNewBagChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" rows={3} data-id="element-230"></textarea>
            </div>
            <div className="flex space-x-2" data-id="element-231">
              <button type="submit" className="px-4 py-2 bg-amber-600 text-white rounded-md hover:bg-amber-700" data-id="element-232">
                Guardar
              </button>
              <button type="button" onClick={() => setShowNewBagForm(false)} className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400" data-id="element-233">
                Cancelar
              </button>
            </div>
          </form>
        </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-234">
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-235">
            <h3 className="text-lg font-semibold mb-2 text-amber-800" data-id="element-236">Café</h3>
            <div className="mb-3" data-id="element-237">
              <select name="bagId" value={formData.bagId} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" required data-id="element-238">
                <option value="" data-id="element-239">Selecciona un café</option>
                {coffeeBags.map(bag => <option key={bag.id} value={bag.id} data-id="element-240">
                    {bag.name} - {bag.origin}
                  </option>)}
              </select>
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-241">
            <h3 className="text-lg font-semibold mb-2 text-amber-800" data-id="element-242">
              Método y Variables
            </h3>
            <div className="mb-3" data-id="element-243">
              <label className="block text-sm font-medium text-amber-700" data-id="element-244">
                Método
              </label>
              <select name="brewMethod" value={formData.brewMethod} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" data-id="element-245">
                <option value="Pour Over" data-id="element-246">Pour Over</option>
                <option value="V60" data-id="element-247">V60</option>
                <option value="Chemex" data-id="element-248">Chemex</option>
                <option value="Aeropress" data-id="element-249">Aeropress</option>
                <option value="French Press" data-id="element-250">French Press</option>
                <option value="Espresso" data-id="element-251">Espresso</option>
                <option value="Moka Pot" data-id="element-252">Moka Pot</option>
              </select>
            </div>
            <div className="flex space-x-2 mb-3" data-id="element-253">
              <div className="w-1/2" data-id="element-254">
                <label className="block text-sm font-medium text-amber-700" data-id="element-255">
                  Café (g)
                </label>
                <input type="number" name="coffeeWeight" value={formData.coffeeWeight} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" step="0.1" min="0" required data-id="element-256" />
              </div>
              <div className="w-1/2" data-id="element-257">
                <label className="block text-sm font-medium text-amber-700" data-id="element-258">
                  Agua (ml)
                </label>
                <input type="number" name="waterWeight" value={formData.waterWeight} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" step="1" min="0" required data-id="element-259" />
              </div>
            </div>
            <div className="mb-3" data-id="element-260">
              <label className="block text-sm font-medium text-amber-700" data-id="element-261">
                Ratio: 1:
                {(formData.waterWeight / formData.coffeeWeight).toFixed(1)}
              </label>
              <div className="h-2 bg-amber-200 rounded-full mt-1" data-id="element-262">
                <div className="h-2 bg-amber-600 rounded-full" style={{
              width: `${Math.min(100, formData.waterWeight / formData.coffeeWeight / 20 * 100)}%`
            }} data-id="element-263"></div>
              </div>
            </div>
            <div className="mb-3" data-id="element-264">
              <label className="block text-sm font-medium text-amber-700" data-id="element-265">
                Tamaño de Molienda
              </label>
              <select name="grindSize" value={formData.grindSize} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" data-id="element-266">
                <option value="Extra Fine" data-id="element-267">Extra Fino</option>
                <option value="Fine" data-id="element-268">Fino</option>
                <option value="Medium-Fine" data-id="element-269">Medio-Fino</option>
                <option value="Medium" data-id="element-270">Medio</option>
                <option value="Medium-Coarse" data-id="element-271">Medio-Grueso</option>
                <option value="Coarse" data-id="element-272">Grueso</option>
                <option value="Extra Coarse" data-id="element-273">Extra Grueso</option>
              </select>
            </div>
            <div className="flex space-x-2 mb-3" data-id="element-274">
              <div className="w-1/2" data-id="element-275">
                <label className="block text-sm font-medium text-amber-700" data-id="element-276">
                  Temperatura (°C)
                </label>
                <input type="number" name="waterTemperature" value={formData.waterTemperature} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" min="0" max="100" data-id="element-277" />
              </div>
              <div className="w-1/2" data-id="element-278">
                <label className="block text-sm font-medium text-amber-700" data-id="element-279">
                  Tiempo (mm:ss)
                </label>
                <input type="text" name="totalBrewTimeDisplay" value={formData.totalBrewTimeDisplay} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" placeholder="00:00" pattern="[0-9]{1,2}:[0-9]{2}" data-id="element-280" />
              </div>
            </div>
            <div className="mb-3" data-id="element-281">
              <label className="block text-sm font-medium text-amber-700" data-id="element-282">
                Detalles de Vertidos
              </label>
              <textarea name="pourDetails" value={formData.pourDetails} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" placeholder="Ej: 0:00 - 50g bloom, 0:30 - hasta 100g, 1:00 - hasta 200g..." rows={3} data-id="element-283"></textarea>
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-284">
            <h3 className="text-lg font-semibold mb-2 text-amber-800" data-id="element-285">
              Resultados
            </h3>
            <div className="mb-3" data-id="element-286">
              <label className="block text-sm font-medium text-amber-700" data-id="element-287">
                TDS (%)
              </label>
              <input type="number" name="tds" value={formData.tds} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" step="0.01" min="0" max="10" data-id="element-288" />
            </div>
            <div className="mb-3" data-id="element-289">
              <label className="block text-sm font-medium text-amber-700" data-id="element-290">
                Rendimiento de Extracción Estimado:{' '}
                {calculateExtractionYield(formData.tds, formData.coffeeWeight, formData.waterWeight).toFixed(2)}
                %
              </label>
              <div className="h-2 bg-amber-200 rounded-full mt-1" data-id="element-291">
                <div className="h-2 bg-amber-600 rounded-full" style={{
              width: `${Math.min(100, calculateExtractionYield(formData.tds, formData.coffeeWeight, formData.waterWeight) / 25 * 100)}%`
            }} data-id="element-292"></div>
              </div>
            </div>
            <h4 className="font-medium mt-4 mb-2 text-amber-700" data-id="element-293">
              Perfil de Sabor
            </h4>
            <FlavorProfile profile={flavorProfile} setProfile={setFlavorProfile} data-id="element-294" />
            <div className="mt-4" data-id="element-295">
              <label className="block text-sm font-medium text-amber-700" data-id="element-296">
                Notas Adicionales
              </label>
              <textarea name="additionalNotes" value={formData.additionalNotes} onChange={handleInputChange} className="w-full px-3 py-2 border border-amber-300 rounded-md" rows={3} placeholder="Notas de cata, observaciones, mejoras para la próxima..." data-id="element-297"></textarea>
            </div>
          </div>
          <button type="submit" className="w-full py-3 bg-amber-600 text-white rounded-md hover:bg-amber-700 font-medium" data-id="element-298">
            Guardar Preparación
          </button>
        </form>}
    </div>;
};